import { Model, Question, Serializer } from "survey-core";

let isPropertyRegistered = false;

export function registerAdminFacingTitleProperty(): void {
  if (isPropertyRegistered) {
    return;
  }
  Serializer.addProperty("question", {
    name: "adminFacingTitle",
    displayName: "Admin Facing Title",
    category: "General",
    default: "",
    visible: false,
    type: "string",
  });
  isPropertyRegistered = true;
}

function hasAdminFacingTitle(question: Question): boolean {
  const adminFacingTitle = question.getPropertyValue("adminFacingTitle");
  return (
    adminFacingTitle &&
    typeof adminFacingTitle === "string" &&
    adminFacingTitle.trim() !== ""
  );
}

export function applyAdminFacingTitles(survey: Model): void {
  registerAdminFacingTitleProperty();

  survey.onGetQuestionTitle.add(
    (sender: Model, options: { question: Question; title: string }) => {
      if (hasAdminFacingTitle(options.question)) {
        options.title = options.question.getPropertyValue("adminFacingTitle");
      }
    },
  );

  const hideDescriptionIfNeeded = (question: Question): void => {
    if (
      hasAdminFacingTitle(question) &&
      question.descriptionLocation !== "hidden"
    ) {
      question.descriptionLocation = "hidden";
    }
  };

  survey.getAllQuestions().forEach(hideDescriptionIfNeeded);

  survey.onAfterRenderQuestion.add(
    (sender: Model, options: { question: Question }) => {
      hideDescriptionIfNeeded(options.question);
    },
  );
}
